import { useEffect, useState } from "react";
import { Modal, SpinningLoader } from "risa-oasis-ui_v2";
import { getFileDownloadUrl } from "../../../api/firebase/firestoreService";
import { ReviewData } from "../../../data-model/reviewModel";
import { ModalId } from "../../../enums/modalId";
import PdfRender from "../../pdfRender/pdfRender";

interface ViewReviewModalProps {
  onClose: () => void;
  reviewData: ReviewData | null;
  isLoading: boolean;
}

const ViewReviewModal = (props: ViewReviewModalProps) => {
  const [pdfUrl, setPdfUrl] = useState<string>("");
  const [isPdfLoading, setIsPdfLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchPdfUrl = async () => {
      if (props.reviewData?.file_path) {
        setIsPdfLoading(true);
        try {
          const url = await getFileDownloadUrl(props.reviewData.file_path);
          setPdfUrl(url);
        } catch (error) {
          console.error("Error fetching PDF URL:", error);
          setPdfUrl("");
        } finally {
          setIsPdfLoading(false);
        }
      } else {
        setPdfUrl("");
      }
    };

    fetchPdfUrl();
  }, [props.reviewData?.file_path]);

  const hasPdf = pdfUrl && !isPdfLoading;

  return (
    <Modal
      dialogId={ModalId.VIEW_REVIEW_MODAL}
      onClose={props.onClose}
      onCancel={props.onClose}
      onSave={() => {}}
      title="Review"
      saveButtonText=""
      cancelText=""
      hideFooter={true}
      heightPercentage={hasPdf ? 75 : undefined}
    >
      {props?.isLoading ? (
        <div className="flex h-full w-full items-center justify-center gap-2 p-5">
          <SpinningLoader />
          <div>Loading Review...</div>
        </div>
      ) : (
        <div className={`flex flex-col gap-5 ${!hasPdf ? "pb-5" : ""}`}>
          {props.reviewData?.comments && (
            <div className="flex flex-col gap-2">
              <div className="tracki text-tiny font-normal leading-h12 tracking-tightest text-primaryGray-2">
                Comments
              </div>
              <div className="flex items-start gap-2.5 self-stretch rounded border border-primaryGray-14 bg-primaryGray-16 px-3 py-3.5">
                <div className="text-tiny font-normal leading-h12 tracking-tightest text-primaryGray-2">
                  {props.reviewData.comments}
                </div>
              </div>
            </div>
          )}
          {props.reviewData?.file_path && pdfUrl.trim().length > 0 && (
            <PdfRender
              file={pdfUrl}
              hideRotateButtons={true}
              hideZoomButtons={true}
            />
          )}
        </div>
      )}
    </Modal>
  );
};

export default ViewReviewModal;
